var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml5Original(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_102_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.037 113.876L9.03198 1.661H118.968L108.952 113.859L63.933 126.339L19.037 113.876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 116.8L100.378 106.714L108.937 10.836H64V116.8Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 52.455H45.788L44.53 38.361H64V24.599H29.489L29.819 28.291L33.201 66.218H64V52.455ZM64 88.198L63.939 88.215L48.612 84.075L47.633 73.1H33.816L35.744 94.709L63.937 102.535L64 102.518V88.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.952 52.455V66.218H80.899L79.302 84.067L63.952 88.21V102.529L92.167 94.709L92.374 92.384L95.608 56.151L95.943 52.455H92.235H63.952ZM63.952 24.599V38.361H97.196L97.472 35.269L98.1 28.291L98.429 24.599H63.952Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_102_34",
    x: -4,
    y: -4,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_102_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_102_34",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Original);
export default __webpack_public_path__ + "static/media/html5-original.86751de634a68d9a0fd6e5b285c988c2.svg";
export { ForwardRef as ReactComponent };